export const APP_VERSION = "1.5.6";

export const HttpStatusCode = {
  OK: 200,
  MultipleChoices: 300,
  BadRequest: 400,
  Unauthorized: 401,
  NotFound: 404,
  InternalServerError: 500,
  UnprocessableEntity: 422,
};

export const keyStorage = {
  user: "user",
};

export const snackbarTypes = {
  ERROR: "error",
  INFO: "info",
  SUCCESS: "success",
  WARNING: "warning",
};

export const specialCharacters = {
  COLON: ":",
  HYPHEN_MINUS: "-",
};

export const typeAlert = {
  CONFIRMATION: "confirmation",
};

export const alertAction = {
  CONFIRM: "Confirm",
  CANCEL: "Cancel",
};

export const DATE_FORMAT = "DD-MMM-YYYY";
export const DATE_FORMAT_SHORT_YEAR = "dd-MMM-yy";

export const excludeDefaultTables = ["DEUDA GUBERNAMENTAL"];

export const widgetType = Object.freeze({
  bmvStocks: "1",
  chart: "2",
  news: "3",
  bivaSic: "4",
  ticker: "5",
  bmvEquity: "100",
  bmvEquitySIC: "103",
  equityBiva: "110",
  SICBIVA: "111",
  indexes: "120",
  nyseNasdaq: "130",
  generalIndicators: "140",
  currencies: "150",
  fixedIncome: "170",
  derivatives: "180",
});

export const LsSubscriptionTableFields = {
  CURRENT_PRICE: "PrecioAcc",
  PREVIOUS_PRICE: "PrecioUHA",
  CHANGE_PROCENTAGE: "VariacionPorcentualAcc",
  CHANGE_UNIT: "VariacionUnitaria",
  VOLUMEN_TOTAL: "VolumenTotal",
  VOLUMEN_DONE: "Volumen",
  NYSE_NASDAQ_EQUITY_VOLUME_DONE: "Hecho_Volumen",
  PURCHASE_VALUE: "CompraPostura",
  PURCHASE: "Compra",
  PURCHASE_VOLUME: "VolCompraPostura",
  SALE_VALUE: "VentaPostura",
  SALE: "Venta",
  SALE_VOLUME: "VolVentaPostura",
  HOUR: "Hora",
  MAXIMUM: "PrecioMaxDia",
  MINIMUM: "PrecioMinDia",
  TOTAL_AMOUNT: "ImporteTotal",
  TOTAL_AMOUNT_INDEX: "ImporteTotal_IndiceSectorial",
  HOUR_INDEX: "Hora_IndiceSectorial",
  DATE_INDEX: "Fecha_IndiceSectorial",
  PREVIOUS_DATE_INDEX: "FechaIndiceAnterior_IndiceSectorial",
  PREVIOUS_PRICE_INDEX: "Cierre_IndiceSectorial",
  OPENING_PRICE: "PrecioApertura",
  SAMPLE_ID: "Muestra",
  DATE: "Fecha",
  DATESTRING: "Stringfecha",
  CURRENT: "Actual",
  PREVIOUS: "Anterior",
  CHANGE: "Variacion",
  PERIODICITY: "Periodicidad",
  PRICE: "Precio",
  CHANGE_PERCENTAGE: "VariacionPorcentual",
  DATE_UHA: "FechaPrecioUHA",
  AMOUNT: "Importe",
  NUMBER_OPERATION: "NumOperaciones",
  SERIES_TRANSMITER: "EmisoraSerie",
  NUM_OF_OPERATIONS: "NumOperaciones",
  PEAK_AMOUNT: "Importe",
  SELLER: "Vendedor",
  BUYER: "Comprador",
  LAST_TIME: "HoraUltimo",
  LAST_DATE: "FechaUltimo",
  FIXED_INCOME_TYPE_VALUE: "DeudaTipoValor",
  FIXED_INCOME_KEY: "DeudaClaveCotizacion",
  FIXED_INCOME_SERIE: "DeudaSerie",
  FIXED_INCOME_DATE: "DeudaFechaEmision",
  FIXED_INCOME_CLEAN_PRICE: "DeudaPrecioLimpio",
  FIXED_INCOME_DIRTY_PRICE: "DeudaPrecioSucio",
  FIXED_INCOME_DAYS_TO_WIN: "DeudaDiasPorVencer",
  FIXED_INCOME_HOUR: "DeudaHoraUltimoHecho",
  FIXED_INCOME_EXPIRATION_DATE: "DeudaFechaVencimiento",
  FIXED_INCOME_PREVIOUS_PRICE: "DeudaCierreAnterior",
  FIXED_INCOME_LAST_DONE: "DeudaUltimoHecho",
  FIXED_INCOME_PORCENTUAL_VARIATION: "DeudaVariacionPorcentual",
  FIXED_INCOME_UNIT_VARIATION: "DeudaVariacionUnitaria",
  FIXED_INCOME_INTEREST_24: "DeudaInteres24H",
  FIXED_INCOME_SCORE_FITCH: "DeudaCalificacionFitch",
  FIXED_INCOME_SCORE_MOODY: "DeudaCalificacionMoody",
  FIXED_INCOME_SCORE_SP: "DeudaCalificacionSP",
  FIXED_INCOME_SCORE_HR: "DeudaCalificacionHR",
  FIXED_INCOME_DAY_MAX: "DeudaMaxDia",
  FIXED_INCOME_DAY_MIN: "DeudaMinDia",
  FIXED_INCOME_PURCHASE_PRICE: "DeudaPrecioCompra",
  FIXED_INCOME_SALE_PRICE: "DeudaPrecioVenta",
  FIXED_INCOME_OPENING_PRICE: "DeudaPrecioApertura",
  FIXED_INCOME_YIELD_RATE: "DeudaTasaRendimiento",
  ISIN: "isin",
  DAYS_TO_EXPIRE: "fixedIncomeDaysToExpire",
  RELEASE_DATE: "fixedIncomeReleaseDate",
  CLEAN_PRICE: "fixedIncomeCleanPrice",
  MD_DIRTY_PRICE: "fixedIncomeMDDirtyPrice",
  MD_CLEAN_PRICE: "fixedIncomeMDCleanPrice",
  DIRTY_PRICE: "fixedIncomeMDDirtyPrice",
  SURTAX_PIP: "fixedIncomeSurtax",
  NYSE_PURCHASE_VALUE: "PosturaCompra_Precio",
  NYSE_PURCHASE_VOLUME: "PosturaCompra_Volumen",
  NYSE_SALE_VALUE: "PosturaVenta_Precio",
  NYSE_SALE_VOLUME: "PosturaVenta_Volumen",
  NYSE_SALE_DATE: "PosturaVenta_Fecha",
  NYSE_SALE_TIME: "PosturaVenta_Fecha",
  NYSE_PURCHASE_DATE: "PosturaCompra_Fecha",
  NYSE_PURCHASE_TIME: "PosturaCompra_Hora",
  NYSE_PURCHASE_STOCK: "PosturaCompra_Bolsa",
  NYSE_SALE_STOCK: "PosturaCompra_Hora",
  NYSE_STOCK_VALUE: "Hecho_Fecha",
  NYSE_MIN_PRICE: "PrecioMinimo",
  NYSE_MAX_PRICE: "PrecioMaximo",
  ACTUAL_VALUE_PPP: "ValorActualPPP",
  SIDE: "Lado",
  PRICE_1: "Precio1",
  PRICE_2: "Precio2",
  PRICE_3: "Precio3",
  PRICE_4: "Precio4",
  PRICE_5: "Precio5",
  PRICE_6: "Precio6",
  PRICE_7: "Precio7",
  PRICE_8: "Precio8",
  PRICE_9: "Precio9",
  PRICE_10: "Precio10",
  PRICE_11: "Precio11",
  PRICE_12: "Precio13",
  PRICE_13: "Precio13",
  PRICE_14: "Precio14",
  PRICE_15: "Precio15",
  PRICE_16: "Precio16",
  PRICE_17: "Precio17",
  PRICE_18: "Precio18",
  PRICE_19: "Precio19",
  PRICE_20: "Precio20",
  NUM_ORDERS_1: "NumOrdenes1",
  NUM_ORDERS_2: "NumOrdenes2",
  NUM_ORDERS_3: "NumOrdenes3",
  NUM_ORDERS_4: "NumOrdenes4",
  NUM_ORDERS_5: "NumOrdenes5",
  NUM_ORDERS_6: "NumOrdenes6",
  NUM_ORDERS_7: "NumOrdenes7",
  NUM_ORDERS_8: "NumOrdenes8",
  NUM_ORDERS_9: "NumOrdenes9",
  NUM_ORDERS_10: "NumOrdenes10",
  NUM_ORDERS_11: "NumOrdenes11",
  NUM_ORDERS_12: "NumOrdenes12",
  NUM_ORDERS_13: "NumOrdenes13",
  NUM_ORDERS_14: "NumOrdenes14",
  NUM_ORDERS_15: "NumOrdenes15",
  NUM_ORDERS_16: "NumOrdenes16",
  NUM_ORDERS_17: "NumOrdenes17",
  NUM_ORDERS_18: "NumOrdenes18",
  NUM_ORDERS_19: "NumOrdenes19",
  NUM_ORDERS_20: "NumOrdenes20",
  VOL_ACCUMULATED_1: "VolAcumulado1",
  VOL_ACCUMULATED_2: "VolAcumulado2",
  VOL_ACCUMULATED_3: "VolAcumulado3",
  VOL_ACCUMULATED_4: "VolAcumulado4",
  VOL_ACCUMULATED_5: "VolAcumulado5",
  VOL_ACCUMULATED_6: "VolAcumulado6",
  VOL_ACCUMULATED_7: "VolAcumulado7",
  VOL_ACCUMULATED_8: "VolAcumulado8",
  VOL_ACCUMULATED_9: "VolAcumulado9",
  VOL_ACCUMULATED_10: "VolAcumulado10",
  VOL_ACCUMULATED_11: "VolAcumulado11",
  VOL_ACCUMULATED_12: "VolAcumulado12",
  VOL_ACCUMULATED_13: "VolAcumulado13",
  VOL_ACCUMULATED_14: "VolAcumulado14",
  VOL_ACCUMULATED_15: "VolAcumulado15",
  VOL_ACCUMULATED_16: "VolAcumulado16",
  VOL_ACCUMULATED_17: "VolAcumulado17",
  VOL_ACCUMULATED_18: "VolAcumulado18",
  VOL_ACCUMULATED_19: "VolAcumulado19",
  VOL_ACCUMULATED_20: "VolAcumulado20",
  GRAPH: "Graficar",
  LIQUIDATION: "Liquidacion",
  SPREAD: "Spread",
  SPREAD_PORCENTAJE: "SpreadPorcentaje",
  POSTURE_TIME: "PosturaHora",
  POSTURE_DATE: "PosturaFecha",
  CURRENCIES_PURCHASE: "PosturaCompra_Precio",
  CURRENCIES_SALE: "PosturaVenta_Precio",
  FULL_HOUR: "HoraCompleta",
  PICO_LOTE: "PicoLote",
  CLOSING_PRICE_DATE: "FechaPrecioCierre",
  BUY_CASH: "CompraCash",
  SALE_CASH: "VentaCash",
  BUY_24HR: "Compra24Hr",
  SALE_24HR: "Venta24Hr",
  BUY_48HR: "Compra48Hr",
  SALE_48HR: "Venta48Hr",
};

export const LsSubscriptionStocksFields = [
  LsSubscriptionTableFields.CURRENT_PRICE,
  LsSubscriptionTableFields.CHANGE_PROCENTAGE,
  LsSubscriptionTableFields.CHANGE_UNIT,
  LsSubscriptionTableFields.VOLUMEN_DONE,
  LsSubscriptionTableFields.VOLUMEN_TOTAL,
  LsSubscriptionTableFields.PURCHASE_VALUE,
  LsSubscriptionTableFields.PURCHASE_VOLUME,
  LsSubscriptionTableFields.SALE_VALUE,
  LsSubscriptionTableFields.SALE_VOLUME,
  LsSubscriptionTableFields.HOUR,
  LsSubscriptionTableFields.MINIMUM,
  LsSubscriptionTableFields.MAXIMUM,
  LsSubscriptionTableFields.DATE,
  LsSubscriptionTableFields.FULL_HOUR,
  LsSubscriptionTableFields.OPENING_PRICE,
  LsSubscriptionTableFields.PREVIOUS_PRICE,
  LsSubscriptionTableFields.PICO_LOTE,
  LsSubscriptionTableFields.ACTUAL_VALUE_PPP,
];

export const LsSubscriptionCurrenciesFields = [
  LsSubscriptionTableFields.CURRENT_PRICE,
  LsSubscriptionTableFields.CHANGE_PROCENTAGE,
  LsSubscriptionTableFields.CHANGE_UNIT,
  LsSubscriptionTableFields.CURRENCIES_PURCHASE,
  LsSubscriptionTableFields.CURRENCIES_SALE,
  LsSubscriptionTableFields.HOUR,
  LsSubscriptionTableFields.NYSE_STOCK_VALUE,
  LsSubscriptionTableFields.MINIMUM,
  LsSubscriptionTableFields.MAXIMUM,
  LsSubscriptionTableFields.FULL_HOUR,
  LsSubscriptionTableFields.CLOSING_PRICE_DATE,
];

export const LsSubscriptionIndexesFields = [
  LsSubscriptionTableFields.CURRENT_PRICE,
  LsSubscriptionTableFields.CHANGE_PROCENTAGE,
  LsSubscriptionTableFields.VOLUMEN_DONE,
  LsSubscriptionTableFields.VOLUMEN_TOTAL,
  LsSubscriptionTableFields.HOUR,
  LsSubscriptionTableFields.MINIMUM,
  LsSubscriptionTableFields.MAXIMUM,
  LsSubscriptionTableFields.PREVIOUS_PRICE_INDEX,
  LsSubscriptionTableFields.TOTAL_AMOUNT,
  LsSubscriptionTableFields.DATE,
  LsSubscriptionTableFields.HOUR_INDEX,
  LsSubscriptionTableFields.PREVIOUS_DATE_INDEX,
  LsSubscriptionTableFields.OPENING_PRICE,
  LsSubscriptionTableFields.CHANGE_UNIT,
  LsSubscriptionTableFields.NYSE_STOCK_VALUE,
];

export const LsSubscriptionGeneralIndicatorsFields = [
  LsSubscriptionTableFields.SAMPLE_ID,
  LsSubscriptionTableFields.DATE,
  LsSubscriptionTableFields.HOUR,
  LsSubscriptionTableFields.CURRENT,
  LsSubscriptionTableFields.PREVIOUS,
  LsSubscriptionTableFields.CHANGE,
  LsSubscriptionTableFields.PERIODICITY,
  LsSubscriptionTableFields.CHANGE_PROCENTAGE,
];

export const LsSubscriptionSICBIVAFields = [
  LsSubscriptionTableFields.PREVIOUS_PRICE,
  LsSubscriptionTableFields.PRICE,
  LsSubscriptionTableFields.VOLUMEN_DONE,
  LsSubscriptionTableFields.CHANGE_UNIT,
  LsSubscriptionTableFields.CHANGE_PERCENTAGE,
  LsSubscriptionTableFields.VOLUMEN_TOTAL,
  LsSubscriptionTableFields.HOUR,
  LsSubscriptionTableFields.DATE,
  LsSubscriptionTableFields.DATE_UHA,
  LsSubscriptionTableFields.AMOUNT,
  LsSubscriptionTableFields.NUMBER_OPERATION,
  LsSubscriptionTableFields.FULL_HOUR,
  LsSubscriptionTableFields.OPENING_PRICE,
  LsSubscriptionTableFields.PICO_LOTE,
];

export const LsSubscriptionEquityBivaFields = [
  LsSubscriptionTableFields.PREVIOUS_PRICE,
  LsSubscriptionTableFields.PRICE,
  LsSubscriptionTableFields.VOLUMEN_DONE,
  LsSubscriptionTableFields.CHANGE_UNIT,
  LsSubscriptionTableFields.CHANGE_PROCENTAGE,
  LsSubscriptionTableFields.VOLUMEN_TOTAL,
  LsSubscriptionTableFields.HOUR,
  LsSubscriptionTableFields.DATE,
  LsSubscriptionTableFields.DATE_UHA,
  LsSubscriptionTableFields.AMOUNT,
  LsSubscriptionTableFields.NUMBER_OPERATION,
  LsSubscriptionTableFields.PURCHASE_VALUE,
  LsSubscriptionTableFields.PURCHASE_VOLUME,
  LsSubscriptionTableFields.SALE_VALUE,
  LsSubscriptionTableFields.SALE_VOLUME,
  LsSubscriptionTableFields.FULL_HOUR,
  LsSubscriptionTableFields.OPENING_PRICE,
  LsSubscriptionTableFields.PICO_LOTE,
  LsSubscriptionTableFields.CURRENT_PRICE,
];

export const LsSubscriptionFixedIncomeFields = [
  LsSubscriptionTableFields.ISIN,
  LsSubscriptionTableFields.FIXED_INCOME_SERIE,
  LsSubscriptionTableFields.FIXED_INCOME_DATE,
  LsSubscriptionTableFields.FIXED_INCOME_PREVIOUS_PRICE,
  LsSubscriptionTableFields.FIXED_INCOME_LAST_DONE,
  LsSubscriptionTableFields.FIXED_INCOME_PORCENTUAL_VARIATION,
  LsSubscriptionTableFields.FIXED_INCOME_UNIT_VARIATION,
  LsSubscriptionTableFields.FIXED_INCOME_INTEREST_24,
  LsSubscriptionTableFields.FIXED_INCOME_SCORE_FITCH,
  LsSubscriptionTableFields.FIXED_INCOME_SCORE_MOODY,
  LsSubscriptionTableFields.FIXED_INCOME_SCORE_SP,
  LsSubscriptionTableFields.FIXED_INCOME_SCORE_HR,
  LsSubscriptionTableFields.DATE,
  LsSubscriptionTableFields.DAYS_TO_EXPIRE,
  LsSubscriptionTableFields.RELEASE_DATE,
  LsSubscriptionTableFields.HOUR,
  LsSubscriptionTableFields.FIXED_INCOME_DAY_MAX,
  LsSubscriptionTableFields.FIXED_INCOME_DAY_MIN,
  LsSubscriptionTableFields.FIXED_INCOME_PURCHASE_PRICE,
  LsSubscriptionTableFields.FIXED_INCOME_SALE_PRICE,
  LsSubscriptionTableFields.FIXED_INCOME_OPENING_PRICE,
  LsSubscriptionTableFields.CLEAN_PRICE,
  LsSubscriptionTableFields.MD_DIRTY_PRICE,
  LsSubscriptionTableFields.MD_CLEAN_PRICE,
  LsSubscriptionTableFields.FIXED_INCOME_YIELD_RATE,
  LsSubscriptionTableFields.DIRTY_PRICE,
  LsSubscriptionTableFields.SURTAX_PIP,
  LsSubscriptionTableFields.FIXED_INCOME_TYPE_VALUE,
  LsSubscriptionTableFields.FULL_HOUR,
  ,
];

export const LsSubscriptionNyseNasdaqFields = [
  LsSubscriptionTableFields.CURRENT_PRICE,
  LsSubscriptionTableFields.PREVIOUS_PRICE,
  LsSubscriptionTableFields.OPENING_PRICE,
  LsSubscriptionTableFields.PRICE,
  LsSubscriptionTableFields.CHANGE_UNIT,
  LsSubscriptionTableFields.CHANGE_PERCENTAGE,
  LsSubscriptionTableFields.VOLUMEN_TOTAL,
  LsSubscriptionTableFields.HOUR,
  LsSubscriptionTableFields.NYSE_PURCHASE_VALUE,
  LsSubscriptionTableFields.NYSE_PURCHASE_VOLUME,
  LsSubscriptionTableFields.NYSE_SALE_VALUE,
  LsSubscriptionTableFields.NYSE_SALE_VOLUME,
  LsSubscriptionTableFields.NYSE_SALE_DATE,
  LsSubscriptionTableFields.NYSE_SALE_TIME,
  LsSubscriptionTableFields.NYSE_PURCHASE_DATE,
  LsSubscriptionTableFields.NYSE_PURCHASE_STOCK,
  LsSubscriptionTableFields.NYSE_STOCK_VALUE,
  LsSubscriptionTableFields.NYSE_MIN_PRICE,
  LsSubscriptionTableFields.NYSE_MAX_PRICE,
  LsSubscriptionTableFields.CHANGE_PROCENTAGE,
  LsSubscriptionTableFields.FULL_HOUR,
];

export const LsSubscriptionBmvEquitySicFields = [
  LsSubscriptionTableFields.CURRENT_PRICE,
  LsSubscriptionTableFields.VOLUMEN_DONE,
  LsSubscriptionTableFields.ACTUAL_VALUE_PPP,
  LsSubscriptionTableFields.CHANGE,
  LsSubscriptionTableFields.CHANGE_PROCENTAGE,
  LsSubscriptionTableFields.VOLUMEN_TOTAL,
  LsSubscriptionTableFields.HOUR,
  LsSubscriptionTableFields.BUYER,
  LsSubscriptionTableFields.LAST_DATE,
  LsSubscriptionTableFields.LAST_TIME,
  LsSubscriptionTableFields.PEAK_AMOUNT,
  LsSubscriptionTableFields.TOTAL_AMOUNT,
  LsSubscriptionTableFields.NUM_OF_OPERATIONS,
  LsSubscriptionTableFields.PREVIOUS_PRICE,
  LsSubscriptionTableFields.MAXIMUM,
  LsSubscriptionTableFields.MINIMUM,
  LsSubscriptionTableFields.SELLER,
  LsSubscriptionTableFields.PURCHASE_VALUE,
  LsSubscriptionTableFields.PURCHASE_VOLUME,
  LsSubscriptionTableFields.SALE_VALUE,
  LsSubscriptionTableFields.SALE_VOLUME,
  LsSubscriptionTableFields.DATE,
  LsSubscriptionTableFields.FULL_HOUR,
  LsSubscriptionTableFields.OPENING_PRICE,
  LsSubscriptionTableFields.PICO_LOTE,
];

export const LsSubscriptionDollarFields = [
  LsSubscriptionTableFields.BUY_CASH,
  LsSubscriptionTableFields.SALE_CASH,
  LsSubscriptionTableFields.BUY_24HR,
  LsSubscriptionTableFields.SALE_24HR,
  LsSubscriptionTableFields.BUY_48HR,
  LsSubscriptionTableFields.SALE_48HR,
  LsSubscriptionTableFields.HOUR,
];

export const LsSubscriptionInvestmentFunds = [
  LsSubscriptionTableFields.CURRENT_PRICE,
  LsSubscriptionTableFields.CHANGE_PROCENTAGE,
  LsSubscriptionTableFields.CHANGE_UNIT,
  LsSubscriptionTableFields.HOUR,
  LsSubscriptionTableFields.MINIMUM,
  LsSubscriptionTableFields.MAXIMUM,
  LsSubscriptionTableFields.DATE,
  LsSubscriptionTableFields.FULL_HOUR,
  LsSubscriptionTableFields.OPENING_PRICE,
  LsSubscriptionTableFields.PREVIOUS_PRICE,
  LsSubscriptionTableFields.PICO_LOTE,
];

export const MarketTypes = {
  BMV: { id: 1, name: "BMV" },
  BMV_SIC: { id: 2, name: "BMV (SIC)" },
  BIVA: { id: 3, name: "BIVA" },
  BIVA_SIC: { id: 4, name: "BIVA (SIC)" },
  NYSE: { id: 5, name: "NYSE, NASDAQ y AMEX" },
  AMEX: { id: 6, name: "AMEX" },
  NASDAQ: { id: 7, name: "NASDAQ" },
  INDEX: { id: 8, name: "\u00cdNDICES" },
  CURRENCY: { id: 9, name: "DIVISAS" },
  DERIVATIVES: { id: 10, name: "DERIVADOS" },
  GENERAL_INDICATORS: { id: 11, name: "INDICADORES" },
  FIXED_INCOME: { id: 12, name: "DEUDA" },
  NYSE_ONLY: { id: 13, name: "NYSE" },
  BANORTE: { id: 15, name: "Fondos Banorte" },
  GOVERNMENT_DEBT: { id: 16, name: "Deuda Gubernamental" },
  INTERNATIONAL_BAGS: { id: 18, name: "Bolsas Internacionales" },
  ECONOMIC_INDICATORS: { id: 21, name: "Indicadores" },
  INTERBANK_DOLLAR: { id: 22, name: "D\u00F3lar Interbancario" },
  INVESTMENT_FUNDS: { id: 23, name: "Fondos de inversi\u00F3n" },
  REFERENCE_RATES: { id: 24, name: "Tasas de Referencia" },
};

export const MarketTypesArray = [
  MarketTypes.BMV,
  MarketTypes.BIVA,
  MarketTypes.BMV_SIC,
  MarketTypes.BIVA_SIC,
  MarketTypes.NYSE,
  MarketTypes.INDEX,
  MarketTypes.CURRENCY,
  MarketTypes.DERIVATIVES,
  MarketTypes.FIXED_INCOME,
  MarketTypes.GENERAL_INDICATORS,
  MarketTypes.NYSE_ONLY,
  MarketTypes.NASDAQ,
  MarketTypes.AMEX,
  MarketTypes.BANORTE,
  MarketTypes.GOVERNMENT_DEBT,
  MarketTypes.INTERNATIONAL_BAGS,
  MarketTypes.ECONOMIC_INDICATORS,
  MarketTypes.INVESTMENT_FUNDS,
  MarketTypes.REFERENCE_RATES,
];
